import { useState, useEffect, useRef, useCallback } from 'react';

export const useIntersectionObserver = (threshold = 0.3) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  const handleIntersection = useCallback((entries) => {
    const entry = entries[0];
    if (entry?.isIntersecting) {
      setIsVisible(true);
    }
  }, [setIsVisible]);

  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) return;

    const observer = new IntersectionObserver(handleIntersection, { threshold });
    observer.observe(currentRef);

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold, handleIntersection]);

  return { ref, isVisible };
};
